// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spinner-border {
    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes spinner-border {
    to {
        transform: rotate(360deg);
    }
}

@keyframes spinner-grow {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {
        opacity: 1;
    }
}

@-webkit-keyframes spinner-grow {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {
        opacity: 1;
    }
}

.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.spinner-border {
    display: inline-block;
    width: 4rem;
    height: 4rem;
    vertical-align: text-bottom;
    border: 0.25em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    -webkit-animation: spinner-border 0.75s linear infinite;
    animation: spinner-border 0.75s linear infinite;
    color: #007bff;
}

.spinner-border-sm {
    width: 2rem;
    height: 2rem;
}

.spinner-grow {
    display: inline-block;
    width: 4rem;
    height: 4rem;
    vertical-align: text-bottom;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    -webkit-animation: spinner-grow 0.75s linear infinite;
    animation: spinner-grow 0.75s linear infinite;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.visually-hidden {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loader/Loader.css"],"names":[],"mappings":"AAAA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,mBAAmB;IACvB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,mBAAmB;IACvB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,iCAAiC;IACjC,+BAA+B;IAC/B,kBAAkB;IAClB,uDAAuD;IACvD,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB","sourcesContent":["@keyframes spinner-border {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes spinner-border {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes spinner-grow {\r\n    0% {\r\n        -webkit-transform: scale(0);\r\n        transform: scale(0);\r\n    }\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes spinner-grow {\r\n    0% {\r\n        -webkit-transform: scale(0);\r\n        transform: scale(0);\r\n    }\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.spinner-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.spinner-border {\r\n    display: inline-block;\r\n    width: 4rem;\r\n    height: 4rem;\r\n    vertical-align: text-bottom;\r\n    border: 0.25em solid currentColor;\r\n    border-right-color: transparent;\r\n    border-radius: 50%;\r\n    -webkit-animation: spinner-border 0.75s linear infinite;\r\n    animation: spinner-border 0.75s linear infinite;\r\n    color: #007bff;\r\n}\r\n\r\n.spinner-border-sm {\r\n    width: 2rem;\r\n    height: 2rem;\r\n}\r\n\r\n.spinner-grow {\r\n    display: inline-block;\r\n    width: 4rem;\r\n    height: 4rem;\r\n    vertical-align: text-bottom;\r\n    background-color: currentColor;\r\n    border-radius: 50%;\r\n    opacity: 0;\r\n    -webkit-animation: spinner-grow 0.75s linear infinite;\r\n    animation: spinner-grow 0.75s linear infinite;\r\n}\r\n\r\n.sr-only {\r\n    position: absolute;\r\n    width: 1px;\r\n    height: 1px;\r\n    padding: 0;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    clip: rect(0, 0, 0, 0);\r\n    white-space: nowrap;\r\n    border: 0;\r\n}\r\n\r\n.visually-hidden {\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
